import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  margin-top: 42px;
  max-height: 492px;
  ${respondTo.desktop`
    margin-top: 20px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    background-color: #ffffff;
    max-width: 360px;
    border-radius: 8px;
    // padding: 20px;
    order: 3;
  `}
`;

export const BonusText = styled.span`
  //font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  margin-left: 6px;
  letter-spacing: -0.18px;
  color: ${({ color = '#FF7828' }) => color};
  //display: flex;
  //align-items: center;
`;

export const BonusDontForgetText = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.18px;
  color: ${({ color = '#ff483b' }) => color};
`;

export const NoDataWrapper = styled.div`
  margin-top: ${({ desktop_mt = 20 }) => desktop_mt}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${respondTo.mobile`
    margin-top: 0;
    padding: 20px 0;
    border-bottom: 1px solid ${colors.elements.border};
  `}
`;

export const NoDataText = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  color: #636262;
  margin-top: 10px;
`;

export const Table = styled.div`
  width: 100%;
`;

export const TableContent = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 600px;
  overflow-y: auto;

  ${respondTo.mobile`
    padding: 0;
    height: ${({ mobileH = 600 }) =>
      mobileH === 'auto' ? mobileH : `${mobileH}px`};
  `}
`;

export const TableRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  font-family: ${fontFamily.primary};
  font-size: ${({ variant }) => (variant === 'Header' ? 16 : 14)}px;
  font-weight: ${({ variant }) => (variant === 'Header' ? '600' : 'normal')};
  line-height: 1.5;
  color: #636262;
  padding: ${({ pb = 10, pt = 10 }) => `${pt}px 0px ${pb}px 0px`};

  &:last-child {
    .list_divider {
      display: none;
    }
  }
`;

export const TabSwitcherWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const TableRowItem = styled.div`
  position: relative;
  flex: ${({ flex = 1 }) => flex};
  display: flex;
  flex-direction: ${({ direction = 'column' }) => direction};
  justify-content: ${({ justify }) => justify};
  align-items: ${({ align }) => align};
  padding: ${({ pl = 0, pr = 0 }) => `0 ${pr}px 0 ${pl}px`};

  span {
    font-size: 14px;
    color: #636262;
  }

  ${respondTo.mobile`
     flex-direction: ${({ mobileDirection }) => mobileDirection};
  `}
`;

export const TableRowHeader = styled.span`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #636262;
`;

export const Divider = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 0.8px;
  background-color: ${colors.elements.primary};
  opacity: 0.6;
`;

export const Icon = styled.span`
  width: 15px;
  height: 24px;
  img {
    width: 100%;
=  }
`;

export const StatusText = styled.span`
  font-size: 14px;
  font-family: ${fontFamily.primary};
  color: ${({ color = '#636262' }) => color} !important;
  margin-left: 5px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Status = styled.span`
  width: 6px;
  height: 6px;
  min-width: 6px;
  min-height: 6px;
  border-radius: 10px;
  background-color: ${({ color = '#fad00b' }) => color};
`;

export const StyledList = styled.ul`
  //max-height: 15vh;
  //overflow-y: auto;
  padding-bottom: ${({ pb = 0 }) => pb}px;
`;

export const StyledListItem = styled.li`
  padding-left: 16px;
  ${respondTo.mobile`
    padding-left: 8px;
  `}
`;

export const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => !['bgColor', 'mr', 'ml', 'mt', 'isActiveForAbsolute', 'isRestaurants'].includes(prop),
})`
  position: relative;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: bold;
  //letter-spacing: -0.17px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-radius: 8px;
  background-color: ${({ bgColor = '#FF7828' }) => bgColor};
  width: 72px;
  min-width: 72px;
  height: 20px;
  border: none;
  cursor: pointer;
  transition: 0.2s ease all;
  margin: ${({ mr = 0, ml = 0, mt = 4 }) => `${mt}px ${mr}px 0 ${ml}px`};

  &:hover {
    background-color: ${({ bgColor }) => bgColor};
    //filter: invert(0) grayscale(0) contrast(2);
  }
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.8;
    `}
  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  ${({ isActiveForAbsolute = false }) =>
    isActiveForAbsolute &&
    css`
      position: absolute;
      right: 0;
      z-index: 0;
      border-radius: 0;
      justify-content: flex-end;
      padding-right: 4px;
      width: calc(100% + 20px);
    `}
  ${({ isRestaurants }) =>
    isRestaurants &&
    css`
      position: absolute;
      right: 0;
    `}
`;

export const ContentWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['mobilePadding'].includes(prop),
})`
  padding: 0 20px;
  height: 395px;
  overflow-y: auto;
  ${respondTo.mobile`
     padding: ${({ mobilePadding = '0 20px' }) => mobilePadding};
     height: 360px;
  `}
`;

export const OrderInfoRow = styled.div.withConfig({
  shouldForwardProp: (prop) => !['desktop_pb', 'desktop_pt'].includes(prop),
})`
  position: relative;
  display: flex;
  align-items: baseline;
  padding-bottom: ${({ desktop_pb = 12 }) => desktop_pb}px;
  padding-top: ${({ desktop_pt = 0 }) => desktop_pt}px;

  ${respondTo.mobile`
    padding-bottom: 10px;
  `}
`;

export const WarningText = styled.p.withConfig({
  shouldForwardProp: (prop) => !['title'].includes(prop),
})`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: ${({ title }) => (title ? 600 : 'normal')};
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ff483b;
`;

export const OrderInfoText = styled.p.withConfig({
  shouldForwardProp: (prop) => !['title', 'tAlign', 'pr', 'pl'].includes(prop),
})`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: 1.5;
  color: #636262;
  flex: 3;
  text-align: ${({ tAlign = 'left' }) => tAlign};
  padding: ${({ pr = 0, pl = 0 }) => `0 ${pr}px 0 ${pl}px`};
  ${({ title }) =>
    !!title &&
    css`
      font-weight: 600;
      flex: 1;
      font-size: 16px;
      text-align: ${({ tAlign = 'left' }) => tAlign};
    `};
  ${respondTo.mobile`
    flex: 1;
  `}
  margin: 0;
  position: relative;
`;

export const OrderSpecialDishes = styled.p`
  //position: absolute;
  top: 100%;
  //font-size: 14px;
  //padding-left: 20px;
  margin: 0;
`;

export const ModalTableRowItem = styled.div`
  flex: 3;
`;

export const MessageDialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`;

export const MessagesBox = styled.div.withConfig({
  shouldForwardProp: (prop) => !['showInput'].includes(prop),
})`
  overflow-y: auto;
  //display: flex;
  //flex-direction: column;
  flex: 1;
  padding: 0 60px;
  ${({ showInput }) =>
    showInput &&
    css`
      max-height: 280px;
      min-height: 280px;
    `}

  ${respondTo.mobile`
      padding: 0;
  `}
`;

export const MessageInputWrapper = styled.div`
  padding: 0 60px;
  display: flex;
  flex: 1;
  height: 100%;
  ${respondTo.mobile`
      padding: 0;
  `}
`;

export const SecondBlock = styled.div`
  //padding-top: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const MessagesBoxItem = styled.div.withConfig({
  shouldForwardProp: (prop) => !['fromMe'].includes(prop),
})`
  border-radius: 6px;
  border: solid 0.5px #ff7828;
  padding: 5px 10px;
  width: 70%;
  max-width: 350px;
  margin-bottom: 15px;
  float: ${({ fromMe }) => (fromMe ? 'left' : 'right')};
`;

export const MessagesBoxItemTitle = styled.p`
  font-size: 10px;
  font-weight: 500;
  //line-height: 3.4;
  text-align: left;
  letter-spacing: -0.17px;
  color: #ff7828;
`;

export const MessagesBoxItemText = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  text-align: left;
  letter-spacing: -0.27px;
  color: #636262;
`;
